module.exports = __webpack_public_path__ + "static/media/mute.406505e7.svg";